import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { FilterService } from '../../../../services/core.filter.service';
import { ProjectService } from '../../../../services/project.service';
import { ProjectReportsData } from '../../services/project.reports.data.service';
import { UiService } from '../../../../services/core.ui.service';
import { ActivityReportHelper } from './project.report.activity.service.component';
import { GfTranslateService } from '../../../../services/core.translate.service';

import * as _ from 'lodash';
import { getActivityItemStateName, getActivityItemStateParams } from '../../../../pipes/activity/activity.functions';

@Component({
    selector: 'project-activity-report',
    template: require('./project.report.activity.component.html')
})
export class ProjectActivityReportComponent implements OnInit {

    @Input() project: any = null;

    protected activity: any = false;
    protected flatActivity: any = false;
    protected filters: any = false;

    protected sortFields: any = null;
    private sort: any = null;
    private paging: any = null;
    private baseFilters: any = null;

    constructor(
        private stateService: StateService, 
        
        private filterService: FilterService,
        private projectService: ProjectService,
        private projectReportsData: ProjectReportsData,
        private uiService: UiService,
        private activityReportHelper: ActivityReportHelper,
        private gfTranslateService: GfTranslateService
    ) { }
    
    ngOnInit() {
        this.sortFields = this.activityReportHelper.getSortFields();
        this.sort = this.filterService.getSortValues();
        this.paging = this.filterService.getPagingValues();
        this.baseFilters = this.activityReportHelper.getBaseFilters();

        var finish = (assignees) => {
            this.baseFilters[5].fieldElements = assignees;

            this.filters = {
                main_fields: this.filterService.setFilterValues(
                    this.baseFilters,
                    this.stateService.params
                )
            };
        }

        // Hook members from promise
        // This method adds the "Any" option to the top of the list.
        this.activityReportHelper.getProjectMembers()
            .then(finish, finish)
            .finally(this.refreshData);
    };

    onApplyFilters = () => {
        this.paging.page_num = 1;
        this.applyFilters();
    };

    onResetFilters = () => {
        this.paging.page_num = 1;
        const clearedParams = {};
        _.forEach(this.baseFilters, (filter: any) => {
            clearedParams[filter.alias] = '';
        });

        this.filters = {
            main_fields: this.filterService.setFilterValues(
                _.cloneDeep(this.baseFilters),
                clearedParams
            )
        };

        this.applyFilters(clearedParams);
    };

    onSort = (params) => {
        this.sort = {
            sort_field: _.get(params, 'key', 'releaseDate'),
            sort_dir: _.get(params, 'sortDir', 'desc')
        };
        this.applyFilters();
    };

    downloadData = (format) => {
        var fetchArgs = this.filterService.getFetchArgs({ project: this.stateService.params.unixName });
        this.projectReportsData.runReport(fetchArgs, format);
    };

    onPaging = (params) => {
        _.assignIn(this.paging, params);
        this.applyFilters();
    };

    addActivityHref = (activityItem) => {
        activityItem.stateName = getActivityItemStateName(activityItem);
        activityItem.stateParams = getActivityItemStateParams(activityItem);
        return activityItem;
    }

    getFilterParams = (paramName: string, paramValue: any): any => {
        const params = {};
        params[paramName] = paramValue;
        return params;
    }

    refreshData = () => {
        this.activity = false;
        this.flatActivity = false;

        var fetchArgs = this.filterService.getFetchArgs({ project: this.stateService.params.unixName });

        this.projectService.report(fetchArgs)
            .then(
                (response) => {
                    const rawItems = _.get(response, 'items', []);
                    this.activity = Object.keys(rawItems).reduce((carry, key) => {
                        carry[key] = rawItems[key].map(
                            this.addActivityHref
                        );
                        return carry;
                    }, {});
                    this.flatActivity = _.reduce(
                        this.activity,
                        (carry, row, key) => {
                            return _.concat(carry, row);
                        }, []
                    );
                },
                () => {
                    this.activity = [];
                    var msg = this.gfTranslateService.translate('There was a problem loading project activity');
                    this.uiService.message.showWarning(msg, 'Data Error');
                }
            );
    }

    applyFilters(overrides = {}) {
        var newParams = _.pickBy(Object.assign(
            { type: 'activity' },
            this.sort,
            this.paging,
            this.filterService.getAllFilterValues(
                _.get(this.filters, 'main_fields', [])
            ),
            overrides
        ), (value) => {
            return (undefined != value && null != value);
        });

        this.stateService.go('.', newParams, { reload: false, location: true, notify: false })
        .then(this.refreshData);
    }
}